import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IEX_STATE_CODES } from '../../../constants/configs/states';
import { ApplicationStatus, IApplication, ALL_USER_ROLES, COVERAGE_YEAR } from '../utils';

export const useShowEligibilityWorkSheet = (application: IApplication): boolean => {
    const environment = useSelector((state: any) => state?.common?.environment);
    const stateCode = environment?.stateCode;
    const activeRoleName = environment?.user?.activeModuleName?.toUpperCase();

    const isValidStateCode = useMemo(() => {
        return [
            IEX_STATE_CODES.ID,
            IEX_STATE_CODES.NJ,
            IEX_STATE_CODES.VA,
            IEX_STATE_CODES.PA,
            IEX_STATE_CODES.NV,
            IEX_STATE_CODES.GA,
        ].includes(stateCode);
    }, [stateCode]);

    const isValidRole = useMemo(() => {
        return [ALL_USER_ROLES.ADMIN, ALL_USER_ROLES.SUPERVISOR, ALL_USER_ROLES.L1_CSR, ALL_USER_ROLES.L2_CSR].includes(
            activeRoleName,
        );
    }, [activeRoleName]);

    const isValidStatus = useMemo(() => {
        return [
            ApplicationStatus.EligibilityReceived,
            ApplicationStatus.PartiallyEnrolled,
            ApplicationStatus.EnrolledOrActive,
            ApplicationStatus.Closed,
        ].includes(application.applicationStatus as ApplicationStatus);
    }, [application.applicationStatus]);

    return useMemo(() => {
        return (
            !application.isNonFinancial &&
            isValidStateCode &&
            isValidRole &&
            Number(application.coverageYear) >= COVERAGE_YEAR &&
            isValidStatus
        );
    }, [application, isValidStateCode, isValidRole, isValidStatus]);
};
